import { Skeleton, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { message, Space } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { confirmEmailReset } from '../../http/user';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../components/AppRouter/AppRouter';
import Button from '../../components/UI/Button/Button';
import { getUser } from '../../redux/selectors';
import { connect } from 'react-redux';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

const ResetPassword = ({ userId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [messageApi, contextHolder] = message.useMessage();
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (Boolean(userId)) {
      navigate(ROUTES.MAIN);
    }

    confirmPassword();
  }, [userId]);

  const confirmPassword = async () => {
    try {
      setLoading(true);
      await dispatch(confirmEmailReset(token));
      setResult('success');
    } catch (error) {
      setResult('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
        width: '100%',
        gap: 40,
        padding: '0 15px'
      }}
    >
      {contextHolder}
      {!loading && (
        <>
          {result === 'success' && <CheckCircleOutlined style={{ color: 'green', fontSize: 60 }} />}
          {result === 'error' && (
            <CloseCircleOutlined style={{ color: 'red', fontSize: 60 }} />
          )}
        </>
      )}
      <Space direction='vertical' size={8}>
        <h2 style={{ textAlign: 'center' }}>
          {t('pages.resetPassword.title')}
        </h2>
        <Skeleton active loading={loading} title={false} paragraph={{ rows: 1, width: '100%' }}>
            <Typography style={{ textAlign: 'center' }}>
              {result === 'success'
                ? t('pages.resetPassword.success')
                : t('pages.resetPassword.error')}
            </Typography>
        </Skeleton>
      </Space>
      <Button onClick={() => navigate(ROUTES.MAIN)}>{t('button.home')}</Button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userId: getUser(state).id
});

export default connect(mapStateToProps)(ResetPassword);
